export const objectMap = <T extends {}, B>(
  record: T,
  mapFct: (key: keyof T, item: T[typeof key]) => B
): Record<keyof T, B> => {
  const keyValues = typedEntries(record).map(([key, value]) => [
    key,
    mapFct(key, value),
  ]);
  const result = Object.fromEntries(keyValues);
  return result as Record<keyof T, B>;
};

export const typedEntries = <T extends {}>(obj: T): [keyof T, T[keyof T]][] => {
  return Object.entries(obj) as [keyof T, T[keyof T]][];
};

export const typedFromEntries = <A extends string | number | symbol, B>(
  entries: [A, B][]
): Record<A, B> => {
  return Object.fromEntries(entries) as Record<A, B>;
};

export const typedKeys = <T extends {}>(obj: T): (keyof T)[] =>
  Object.keys(obj) as (keyof T)[];

export const omit = <T, Key extends keyof T>(
  obj: T,
  key: Key
): Omit<T, Key> => {
  const copy = { ...obj };
  delete copy[key];
  return copy;
};

export const omitMultiple = <T extends {}>(obj: T, keys: (keyof T)[]) => {
  const copy = { ...obj };
  keys.forEach((key) => {
    delete copy[key];
  });
  return copy;
};
